import { CloseOutlined } from '@ant-design/icons';
import type { ButtonProps } from 'antd';
import { Button } from 'antd';
import { useCallback } from 'react';

import { showConfirmModal } from '@/components/ConfirmModal';

interface Props extends Omit<ButtonProps, 'onClick'> {
  onDiscardChanges: () => void;
  showConfirmationModal?: boolean;
}

export const DiscardChangesButton = ({
  onDiscardChanges,
  showConfirmationModal,
  ...buttonProps
}: Props) => {
  const handleClick = useCallback(() => {
    if (showConfirmationModal) {
      showConfirmModal({
        title: 'Discard Changes',
        content: 'Are you sure you want to discard all changes?',
        onOk: onDiscardChanges
      });

      return;
    }

    onDiscardChanges();
  }, [onDiscardChanges, showConfirmationModal]);

  return (
    <Button icon={<CloseOutlined />} onClick={handleClick} {...buttonProps}>
      Cancel
    </Button>
  );
};

export default DiscardChangesButton;
